import { WidgetAction } from './WidgetManager';

export interface TaskMapping {
  task: string;
  intent: string;
  requiredAgents: string[];
  widget: {
    type: string;
    component: string;
  };
  actions: WidgetAction[];
  confidence: number;
}

export class TaskWidgetMappingRegistry {
  private mappings: Map<string, TaskMapping> = new Map();

  constructor() {
    this.initializeMappings();
  }

  private initializeMappings() {
    // Cash Position Mapping
    this.mappings.set('cash-position', {
      task: 'cash-position-analysis',
      intent: 'cash-position',
      requiredAgents: ['Windrose', 'Tell Tale'],
      widget: {
        type: 'cash-position',
        component: 'CashPositionWidget'
      },
      actions: [
        { actionType: 'get-position', label: 'Get Current Position', priority: 1 },
        { actionType: 'forecast', label: 'View Forecast', priority: 2 }
      ],
      confidence: 0.95
    });

    // Payment Acceleration Mapping
    this.mappings.set('payment-acceleration', {
      task: 'payment-acceleration-analysis',
      intent: 'payment-acceleration',
      requiredAgents: ['Poniente', 'Full Send'],
      widget: {
        type: 'payment-acceleration',
        component: 'PaymentAccelerationWidget'
      },
      actions: [
        { actionType: 'find-opportunities', label: 'Find Opportunities', priority: 1 },
        { actionType: 'accelerate', label: 'Accelerate Payment', priority: 2 }
      ],
      confidence: 0.88
    });

    // Vendor Payments Mapping
    this.mappings.set('vendor-payments', {
      task: 'vendor-payment-optimization',
      intent: 'vendor-payments',
      requiredAgents: ['Poniente', 'Windrose'],
      widget: {
        type: 'vendor-payments',
        component: 'VendorPaymentWidget'
      },
      actions: [
        { actionType: 'optimize', label: 'Optimize Payments', priority: 1 },
        { actionType: 'schedule', label: 'Schedule Payments', priority: 2 }
      ],
      confidence: 0.92
    });

    // Contract Qualification Mapping
    this.mappings.set('contract-qualification', {
      task: 'contract-qualification-analysis',
      intent: 'contract-qualification',
      requiredAgents: ['Levante', 'Windrose'],
      widget: {
        type: 'contract-qualification',
        component: 'ContractQualificationWidget'
      },
      actions: [
        { actionType: 'check-strength', label: 'Check Financial Strength', priority: 1 },
        { actionType: 'qualify', label: 'Qualify for Contract', priority: 2 }
      ],
      confidence: 0.94
    });

    // Cross Border Mapping
    this.mappings.set('cross-border', {
      task: 'cross-border-optimization',
      intent: 'cross-border',
      requiredAgents: ['Hooked In', 'Poniente'],
      widget: {
        type: 'cross-border',
        component: 'CrossBorderWidget'
      },
      actions: [
        { actionType: 'analyze', label: 'Analyze Exposure', priority: 1 },
        { actionType: 'optimize', label: 'Optimize FX', priority: 2 }
      ],
      confidence: 0.89
    });
  }

  getMapping(intent: string): TaskMapping | undefined {
    return this.mappings.get(intent);
  }

  getAllMappings(): TaskMapping[] {
    return Array.from(this.mappings.values());
  }

  addMapping(intent: string, mapping: TaskMapping): void {
    this.mappings.set(intent, mapping);
  }
}